import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  mainDiv: {
    width: "100%",
    background: "linear-gradient(90deg, #F9FAFB 0%, #F2F4F7 100%)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "60px",
    padding: "80px 120px",
    "@media (max-width: 600px)": {
      padding: "40px 40px"
    }
  },
  rightBox: {
    padding: "16px",
    height: "100%"
  },
  leftBox: {
    width: "100%",
    height: "100%",
    borderRadius: "12px 0px 0px 12px",
    background: "#FAFCFE",
    margin: "0 auto"
  },
  container: {
    height: "100%",
    width: "100%",
    margin: "0 auto",
    background: "#FFF",
    boxShadow: "2px 1px 5px rgba(152, 162, 179, 0.15), 0px 4px 10px rgba(48, 140, 219, 0.05)",
    borderRadius: "12px"
  },
  image: {
    maxWidth: "200px",
    marginTop: "5%",
    marginLeft: "8.5%",
    height: "5vh",
  },
  imageConfirmEmail: {
    width: "80%"
  },
  imageConfirmEmailContainer: {
    height: "40.2vh",
    width: "100%",
    marginTop: "8%",
    display: "flex",
    justifyContent: "center"
  },
}));

export default styles;
